import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { HashRouter, Route } from 'react-router-dom'

import AppConfig from './Data/AppConfig.js'
import gobjUISettings from './Data/AppUI.js'
import * as AppVariables from './Data/AppVariables.js';
import * as Globals from './Utils/Globals.js';

import * as LocalStorage from './Data/LocalStorage.js'
import {
    ClientGatewayInPackage, 
    PackageVariablesLibs, 
    LocalStorageLibs, 
    AudioLibs, 
    GoogleOAuthLibs, 
    AppleOAuthLibs, 
    GlobalLibs, 
    TimeZoneLibs, 
    CreateJSLibs
} from 'bc-react-package'


const COMP_NAME = "index"
let mobjQueryStringArgs = {};

// Richard： 在非 develoment 的時候，不顯示 console.log
function NoConsoleLog()
{}
console.log("Version: ", process.env.REACT_APP_LOG_VERSION)
console.log("process.env.REACT_APP_LOG_DUMP: ", process.env.REACT_APP_LOG_DUMP)

if (process.env.REACT_APP_LOG_DUMP === "false")
{

    console.log = NoConsoleLog;
    console.warn = NoConsoleLog;
    // console.error = NoConsoleLog;
}

function ParseQueryStringArgs()
{
    console.log(COMP_NAME + ".ParseQueryStringArgs");
    console.log("window.location: ", window.location);
    console.log("window.location.search: ", window.location.search);

    var strUrl = window.location.search; // ?arg1=xx&arg2=yy ...
    var strArgs = ""; // arg1=xx&arg2=yy ...
    var arrArgs = []; // [arg1=xx, arg2=yy] ...
    var intArgsLen = 0;
    var i = 0;
    var arrArgNameValuePair = []; // [arg1, xx]

    if (strUrl.indexOf("?") !== -1) // get args
    {
        strArgs = (strUrl.split("?")[1]).trim();
        if (strArgs !== "")
        {
            arrArgs = strArgs.split("&");
            intArgsLen = arrArgs.length;
            for (i = 0; i < intArgsLen; i++)
            {
                arrArgNameValuePair = arrArgs[i].split("=");
                mobjQueryStringArgs[arrArgNameValuePair[0]] = arrArgNameValuePair[1];
            }
        }
    }

    console.log("mobjQueryStringArgs: ", mobjQueryStringArgs);

} // end of ParseQueryStringArgs

function InitAppSessionVars()
{
    console.log("InitAppSessionVars: ", mobjQueryStringArgs);

    // iOSNewGateway
    if ((typeof(mobjQueryStringArgs.iOSNewGateway) !== 'undefined') && (mobjQueryStringArgs.iOSNewGateway === "true"))
    {
        window.gSession.App.iOSNewGateway = true;
    }
    // ClearAll
    if (
        ((typeof(mobjQueryStringArgs.ClearAll) !== 'undefined') && (mobjQueryStringArgs.ClearAll === "true")) ||
        ((typeof(mobjQueryStringArgs.ClearAll) !== 'undefined') && (mobjQueryStringArgs.ClearAll === "true"))
    )
    {
        window.gSession.App.ClearAll = true;
    }
    // InApp
    if (
        ((typeof(mobjQueryStringArgs.inApp) !== 'undefined') && (mobjQueryStringArgs.inApp === "true")) ||
        ((typeof(mobjQueryStringArgs.InApp) !== 'undefined') && (mobjQueryStringArgs.InApp === "true"))
    )
    {
        window.gSession.App.InApp = true;
        window.gSession.App.LoginDevice = 1; // "LoginDevice": 2,               // 1: inApp, 2: Web   
    }
    else
    {
        window.gSession.App.InApp = false;
        window.gSession.App.LoginDevice = 2;
    }
    // iOSVer
    if ((typeof(mobjQueryStringArgs.iOSVer) !== 'undefined') && (mobjQueryStringArgs.iOSVer !== ""))
    {
        window.gSession.App.iOSVer = mobjQueryStringArgs.iOSVer;
    }
    // Env
    if ((typeof(mobjQueryStringArgs.Env) !== 'undefined') && (mobjQueryStringArgs.Env !== ""))
    {
        switch (parseInt(mobjQueryStringArgs.Env))
        {
            case 1:
                window.gSession.App.Env = "Dev";
                break;
            case 2:
                window.gSession.App.Env = "Integration";
                break;
            case 3:
                window.gSession.App.Env = "Staging";
                break;
            default:
                window.gSession.App.Env = "Production";
                break;
        }
    }

    // InitAccountID  
    if ((typeof(mobjQueryStringArgs.AccountID) !== 'undefined') && (mobjQueryStringArgs.AccountID !== ""))
    {
        window.gSession.App.InitAccountID = parseInt(mobjQueryStringArgs.AccountID);
    }

    // InitCredential       從Report傳來的ACTION_OPEN_BETTER_IMMERSION_APP的參數
    if ((typeof(mobjQueryStringArgs.Credential) !== 'undefined') && (mobjQueryStringArgs.Credential !== ""))
    {
        window.gSession.App.InitCredential = mobjQueryStringArgs.Credential;
    }

    // AppVersion
    if ((typeof(mobjQueryStringArgs.AppVersion) !== 'undefined') && (mobjQueryStringArgs.AppVersion !== ""))
    {
        window.gSession.App.AppVersion = mobjQueryStringArgs.AppVersion;
    }

    if ((typeof(mobjQueryStringArgs.Volume) !== 'undefined') && (mobjQueryStringArgs.Volume !== ""))
    {
        console.log("mobjQueryStringArgs.Volume:", mobjQueryStringArgs.Volume)
        window.gSession.App.Volume = mobjQueryStringArgs.Volume;   
    }

    // InitGCShare
    if ((typeof(mobjQueryStringArgs.GCShare) !== 'undefined') && (mobjQueryStringArgs.GCShare !== ""))
    {
        window.gSession.App.InitGCShare = mobjQueryStringArgs.GCShare;
    }

    // VEUserKey   驗證eMail User Key   Tim21.12.21
    if ((typeof (mobjQueryStringArgs.VEUserKey) !== 'undefined') && (mobjQueryStringArgs.VEUserKey !== ""))
    {
        console.log("InitAppSessionVars: mobjQueryStringArgs.VEUserKey:", mobjQueryStringArgs.VEUserKey)
        window.gSession.App.VEData.UserKey = mobjQueryStringArgs.VEUserKey
    }

    // VECode   驗證eMail Code   Tim21.12.21
    if ((typeof (mobjQueryStringArgs.VECode) !== 'undefined') && (mobjQueryStringArgs.VECode !== ""))
    {
        console.log("InitAppSessionVars: mobjQueryStringArgs.VECode:", mobjQueryStringArgs.VECode)
        window.gSession.App.VEData.Code = mobjQueryStringArgs.VECode
    }

    // VEEmailAddr   驗證eMail Code   Tim21.12.21
    if ((typeof (mobjQueryStringArgs.VEEmailAddr) !== 'undefined') && (mobjQueryStringArgs.VEEmailAddr !== ""))
    {
        console.log("InitAppSessionVars: decodeURIComponent(mobjQueryStringArgs.VEEmailAddr:", decodeURIComponent(mobjQueryStringArgs.VEEmailAddr))
        window.gSession.App.VEData.EmailAddr = decodeURIComponent(mobjQueryStringArgs.VEEmailAddr)
    }

    window.gSession.App.MinutesOffset = TimeZoneLibs.GetMinutesOffset(-1, -1); // 2 is off
    console.log("gSession.App.MinutesOffset: ", window.gSession.App.MinutesOffset);

    // DeviceType4LogTrace 一定要比 BrowserType4LogTrace 早
    // InApp 一定要比 BrowserType4LogTrace 早
    // window.gSession.App.DeviceType4LogTrace = window.Globals.GetDeviceType4LogTrace();
    // window.gSession.App.BrowserType4LogTrace = window.Globals.GetBrowserType4LogTrace();
    window.gSession.App.DeviceType4LogTrace = GlobalLibs.GetDeviceType4LogTrace();
    window.gSession.App.BrowserType4LogTrace = GlobalLibs.GetBrowserType4LogTrace();
    console.log("window.gSession.App.DeviceType4LogTrace: ", window.gSession.App.DeviceType4LogTrace)
    console.log("window.gSession.App.BrowserType4LogTrace: ", window.gSession.App.BrowserType4LogTrace)
} // end of InitAppSessionVars

function InitAppConfig(EnvName)
{
    console.log(COMP_NAME + ".InitAppConfig: ", EnvName);

    return AppConfig[EnvName];
}

function InitGlobalVariables()
{
    console.log(COMP_NAME + ".InitGlobalVariables")

    // window.gWSServerTypeEnum = AppVariables.gWSServerTypeEnum
    // window.gLoginFlag = JSON.parse(JSON.stringify(AppVariables.gLoginFlag))    
    window.gButtonTypeEnum = AppVariables.gButtonTypeEnum
    window.gDataStatusFromAppEnum = AppVariables.gDataStatusFromAppEnum
    window.gDataStatusFromAppIAPEnum = AppVariables.gDataStatusFromAppIAPEnum
    window.gResultCodeForAppInAppPurchaseSwiftUIEnum = AppVariables.gResultCodeForAppInAppPurchaseSwiftUIEnum
    window.gLangTypeEnum = AppVariables.gLangTypeEnum
    window.gAccPreferenceTypeEnum = AppVariables.gAccPreferenceTypeEnum
    window.gSettingsFuncIndexEnum = AppVariables.gSettingsFuncIndexEnum
    window.gNewAssignmentStatusEnum = AppVariables.gNewAssignmentStatusEnum
    window.gPracticeLUIndexEnum = AppVariables.gPracticeLUIndexEnum
    window.gAssignReportStatusEnum = AppVariables.gAssignReportStatusEnum
    window.gDCPLUEnum = AppVariables.gDCPLUEnum
    window.gEventModeEnum = AppVariables.gEventModeEnum
    window.gChangeAnimationTypeEnum = AppVariables.gChangeAnimationTypeEnum
    window.gSwipeDirectionEnum = AppVariables.gSwipeDirectionEnum
    window.gAuthorizedSubscriptionTypeEnum = AppVariables.gAuthorizedSubscriptionTypeEnum
    window.gLoginAfterStatusEnum = AppVariables.gLoginAfterStatusEnum
    // window.gBrowserTypeEnum = AppVariables.gBrowserTypeEnum
    // window.gBrowserTypeEnum = GlobalLibs.BrowserTypeEnum
    // window.gDeviceType4LogTraceEnum = AppVariables.gDeviceType4LogTraceEnum
    // window.gDeviceType4LogTraceEnum = GlobalLibs.DeviceType4LogTraceEnum
    window.gResourceTypeEnum = AppVariables.gResourceTypeEnum
    window.gQuestionTypeEnum = AppVariables.gQuestionTypeEnum
    window.gAudioStatusEnum = AppVariables.gAudioStatusEnum

    window.gDCPJsonEnum = AppVariables.gDCPJsonEnum

    window.ComponentFuncEntry = AppVariables.gComponentFuncEntry
    window.gAppURLSchemes = AppVariables.gAppURLSchemes
    window.gAppiTunesURL = AppVariables.gAppiTunesURL
    
    window.garrPracticeLU = AppVariables.garrPracticeLU
    window.garrCountry = AppVariables.garrCountry
    window.gobjPreludeMenu = AppVariables.gobjPreludeMenu
    window.gDateTimeFormatEnum = AppVariables.gDateTimeFormatEnum
    window.gEmailVerifyEnum = AppVariables.gEmailVerifyEnum
} // end of InitGlobalVariables

function EnterApplication()
{
    console.log(COMP_NAME + ".EnterApplication");
    // window.ApplicationInited = true

    console.log("window.location.hash: ", window.location.hash)
    console.log("window.location.pathname: ", window.location.pathname)
    // Richard: 避免 User 自己打 Url or Refresh
    if (window.location.hash !== "")
    {
        // e.g. https://olsnew.local.betterchinese.com.tw:3008?Name01=CCC&Name02=DDD#/Home1?Key01=AAA&Key02=BBB 中移除 #/Home1?Key01=AAA&Key02=BBB
        window.location.hash = ""
    }

    // render the first node
    ReactDOM.render(
        <HashRouter>
            <Route path="/" component={App} />
        </HashRouter>,
        document.getElementById("root")
    )
}

function QueryStringContainUUID()
{
    console.log(COMP_NAME + ".QueryStringContainUUID: ", mobjQueryStringArgs.UUID)

    let blnHasUUID = false
    if(
        (typeof(mobjQueryStringArgs.UUID) !== 'undefined') &&
        (mobjQueryStringArgs.UUID !== "")
    )
    {
        blnHasUUID = true
    }
    return blnHasUUID
}

// 為了避免瀏覽器cache 所以在原本的URL後面加上UUID="XXXXX" 強制讓瀏覽器重新讀取內容
function URLAppendUUID()
{
    console.log(COMP_NAME + ".URLAppendUUID: ")

    console.log("window.location.origin: ", window.location.origin)
    console.log("window.location.pathname: ", window.location.pathname)
    console.log("window.location.search: ", window.location.orsearchgin)

    let strSearch = window.location.search
    let strUrl = window.location.origin + window.location.pathname
    if (window.location.pathname.slice(-1) !== "/")
    {
        // 當最後一個 character 不是 /

        strUrl += "/"
    }
    
    if (strSearch === "")
    {
        strSearch += "?"  
    }
    else
    {
        strSearch += "&"
    }
    strSearch += "UUID=" + GlobalLibs.GenerateUUID()
    strUrl += strSearch

    console.log("strUrl: ", strUrl)
    window.location.href = strUrl
}

function InitLocalStorage()
{
    console.log(COMP_NAME + ".Init");

    // richard: Libs 只提供  ACC, APP 的 Init
    LocalStorageLibs.InitLocalStorage(LocalStorage, window.gSession.App.ClearAll)

    // 每個 Project 自己多的 Local Storage Key 需要自己 Init
    if (
        (typeof (localStorage.getItem(LocalStorage.GLOSSARY_LS_KEY)) === 'undefined') ||
        (localStorage.getItem(LocalStorage.GLOSSARY_LS_KEY) === null) ||
        (localStorage.getItem(LocalStorage.GLOSSARY_LS_KEY) === "")
        )
    {
        localStorage.setItem(LocalStorage.GLOSSARY_LS_KEY, JSON.stringify(LocalStorage.gGlossaryLocalStorage))
    }
}
function Init()
{
    console.log(COMP_NAME + ".Init: ");

    // let intTest = 123
    // console.log("intTest.PadLeft(5): ", intTest.PadLeft(5))

    // let strTest = "123"
    // console.log("strTest.PadLeft(3): ", strTest.PadLeft(5))

    // let objNow = new Date()
    // console.log("objNow: ", objNow)
    // console.log("objNow.GetUTCTime(): ", objNow.GetUTCTime())
    // let strNow = "15:1:23"
    // console.log("strNow.Formate12HDisplayTimeByString(): ", strNow.Formate12HDisplayTimeByString())
    // strNow = "5:10:3"
    // console.log("strNow.Formate12HDisplayTimeByString(): ", strNow.Formate12HDisplayTimeByString())
    // let datUTC = objNow.LocalDateToUTC(480) // window.gSession.App.MinutesOffset,
    // console.log("datUTC: ", datUTC)
    // let datLocal = datUTC.UTCToLocalDate(480) // window.gSession.App.MinutesOffset,
    // console.log("datLocal: ", datLocal)
    // return
    // console.log("objNow.FormateBCDisplayDateTime(): ", objNow.FormateBCDisplayDateTime())
    // console.log("objNow.ToBCUTCString(): ", objNow.ToBCUTCString())
    // console.log("objNow.ToBCLocalTimeString(): ", objNow.ToBCLocalTimeString())

    // let objUTC = objNow.ToBCLocalTimeString().ToUTC()
    // console.log("objUTC: ", objUTC)
    // console.log("objUTC.ToBCUTCString(): ", objUTC.ToBCUTCString())
    // console.log("objUTC.ToBCLocalTimeString(): ", objUTC.ToBCLocalTimeString())

    // return 
    // window.ApplicationInited = false
    window.Globals = Globals
    window.ClientGatewayInPackage = ClientGatewayInPackage
    window.gConst = AppVariables.gConst
    window.gSession = JSON.parse(JSON.stringify(AppVariables.gSession))
    
    console.log(COMP_NAME + ".Init gConst: ", window.gConst)
    console.log(COMP_NAME + ".Init gSession: ", window.gSession)

    InitGlobalVariables()

    window.GoogleOAuthLibs = GoogleOAuthLibs
    // window.FBOAuthLibs = FBOAuthLibs
    window.AppleOAuthLibs = AppleOAuthLibs
    // window.AudioLibs = utilAudioLibs
    window.AudioLibs = AudioLibs

    window.AppVariables = AppVariables  // richard 20230731 加入，讓 BCReactPackage 可以取得 AppVariables.gSession.Acc 的定義
    ParseQueryStringArgs()
    InitAppSessionVars()

    // 在ParseQueryStringArgs()之後 檢查Query String有無
    if(
        !window.gSession.App.InApp &&
        !QueryStringContainUUID()
        )
    {
        // 若沒有 UUID="XXX"時 則自動加上去
        URLAppendUUID()
    }

    console.log(COMP_NAME + ".Init gSession: ", window.gSession)

    window.gConfig = InitAppConfig(window.gSession.App.Env)
    console.log(COMP_NAME + ".Init window.gConfig: ", window.gConfig)

    window.gAppUI = gobjUISettings["en_US"]
    console.log(COMP_NAME + ".Init window.gAppUI: ", window.gAppUI)

    InitLocalStorage()
    // window.Globals.InitLocalStorage()

    window.AudioLibs.Init()

    // StartGame4CreateJSUse()
    
    let objPackageVariablesInitArgs = {
        AppID: window.gConst.APP_ID,
        UILocale: "en_US",
        // BundleID: window.gConst.BUNDLE_ID,
        ReactAppLogVersion: process.env.REACT_APP_LOG_VERSION,
        iTunesAppID: window.gConst.iTUNES_APP_ID,
        BookCategoryID4Auth: 0,
        CallAppAPIFuncRef: window.CallAppAPI
    }
    PackageVariablesLibs.Init(objPackageVariablesInitArgs)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.PackageVariables: ", PackageVariablesLibs.PackageVariables)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.SysConfig: ", PackageVariablesLibs.SysConfig)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.UISettings: ", PackageVariablesLibs.UISettings)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.BundleIDEnum: ", PackageVariablesLibs.BundleIDEnum)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.SysTypeEnum: ", PackageVariablesLibs.SysTypeEnum)
    console.log(COMP_NAME + ".Init PackageVariablesLibs.PackageVersion: ", PackageVariablesLibs.PackageVersion)
    
    CreateJSLibs.Init() // StartGame4CreateJSUse

    EnterApplication() // Production
}

// setTimeout(function(){ 
    Init();
// }, 10000)

